import { ValueOf } from '@redsift/design-system';

export const ColorTheme = {
  default: 'default',
  dark: 'dark',
  darker: 'darker',
  darkerer: 'darkerer',
  light: 'light',
  lighter: 'lighter',
  lighterer: 'lighterer',
  monochrome: 'monochrome',
} as const;
export type ColorTheme = ValueOf<typeof ColorTheme>;

export type SuccessDangerColorTheme = {
  success: string;
  warning: string;
  danger: string;
  neutral?: string;
};

export type CustomColorTheme = Record<string, string>;

export type ChartTheme =
  | ColorTheme
  | SuccessDangerColorTheme
  | CustomColorTheme;
